import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  productList: {
    marginTop: 48,
    maxWidth: 1720
  }
})
